__turbopack_context__.v({
  "message-highlight": "Z_mVEq_message-highlight",
  "navigation-highlight": "Z_mVEq_navigation-highlight",
  "timeline": "Z_mVEq_timeline",
});
